<div class="flex flex-col h-full w-full">
  @if (!calledFromCheck) {
    <app-page-header>
      <div class="flex flex-row justify-start items-center gap-2 h-10">
        <span>{{ headline }}</span>
      </div>
      <!-- gap-4 ist der einheitliche Knopfabstand aller Topbars (siehe app-page-header). Hier stand
           lange gap-2: das <bic-dropdown> belegte als leerer Host einen Flex-Slot und erzeugte an
           dieser einen Stelle einen doppelten Abstand, worauf der Gap global halbiert wurde. Das
           Dropdown bringt inzwischen selbst `:host{display:contents}` mit, der Slot faellt weg -
           die Halbierung ist damit erledigt. -->
      <div class="flex flex-row gap-4 min-w-0 overflow-x-auto shrink">
        <bic-button (onClick)="navigateToDocumentClasses()" buttonType="white">Dokumentenklassen
          <fa-icon [icon]="faGear" iconLeft></fa-icon>
        </bic-button>
        <!-- Loeschen legt seit 2026-09-07 nur in den Papierkorb; von hier kommt man wieder ran. -->
        <bic-button (onClick)="openTrash()" buttonType="white">Papierkorb
          <fa-icon [icon]="faTrash" iconLeft></fa-icon>
        </bic-button>
        @if (writeBlockedReason) {
<div [tooltip]="writeBlockedReason">
          <bic-button [bicDropdownTrigger]="uploadMenuDropdown" [disabled]="true" buttonType="white">Hochladen
            <fa-icon [icon]="faArrowUpFromBracket" iconLeft></fa-icon>
          </bic-button>
        </div>
}
        @if (!writeBlockedReason) {
<bic-button [bicDropdownTrigger]="uploadMenuDropdown" buttonType="white">Hochladen
          <fa-icon [icon]="faArrowUpFromBracket" iconLeft></fa-icon>
        </bic-button>
}
        <bic-dropdown #uploadMenuDropdown [dropdownPlacement]="'bottom-end'"
                      class="contents">
          <bic-dropdown-element (click)="$event.stopPropagation(); uploadInput.click()">
            <div class="flex flex-row text-sm gap-3 text-gray-700 items-center">
              <fa-icon class="text-gray-700 w-4" [icon]="faFile"></fa-icon>
              <span>Dateien</span>
            </div>
          </bic-dropdown-element>
          <bic-dropdown-element (click)="$event.stopPropagation(); uploadFolderInput.click()">
            <div class="flex flex-row text-sm gap-3 text-gray-700 items-center">
              <fa-icon class="text-gray-700 w-4" [icon]="faFolderOpen"></fa-icon>
              <span>Ordner</span>
            </div>
          </bic-dropdown-element>
          <!-- Externe Datenquellen (BIC-Frontend#2720) -->
          <bic-dropdown-element (click)="$event.stopPropagation(); linkSourceFolder()">
            <div class="flex flex-row text-sm gap-3 text-gray-700 items-center">
              <img src="assets/connectors/sharepoint.svg" alt="" class="w-4 h-4">
              <span class="whitespace-nowrap">Mit SharePoint verknüpfen</span>
            </div>
          </bic-dropdown-element>
        </bic-dropdown>
        <input #uploadInput (change)="openUploadSelection($event)"
               accept=".pdf, .ifc, .xlsx, .pptx, .docx" hidden id="uploadInput" multiple type="file">
        <input #uploadFolderInput (change)="openUploadSelection($event, true)" directory hidden id="uploadFolderInput"
               type="file" webkitdirectory>
        @if (writeBlockedReason) {

          <div [tooltip]="writeBlockedReason">
            <bic-button [disabled]="true" buttonType="white">Neuer Ordner
              <fa-icon [icon]="faFolderPlus" iconLeft></fa-icon>
            </bic-button>
          </div>
        
} @else {

          <bic-button (onClick)="addFolder()" buttonType="white">Neuer Ordner
            <fa-icon [icon]="faFolderPlus" iconLeft></fa-icon>
          </bic-button>
        
}
        
      </div>
    </app-page-header>
  }
  <div class="flex flex-row w-full h-full gap-6 overflow-hidden" [ngClass]="{'p-6': !noOuterPadding}">
    <div [ngClass]="{'gap-6': filteredData.length == 0}"
         class="flex flex-col w-full h-full border-gray-200 border rounded-lg min-w-0">
      <div class="flex w-full flex-col rounded-lg h-full">
        <div class="flex flex-col w-full justify-between items-center gap-3 p-4">
          <!-- Breadcrumb row -->
          <div class="flex items-center justify-between w-full min-w-0 gap-4 overflow-hidden">
            <!-- links: MUSS schrumpfen dürfen (w-0 ist hier der entscheidende Fix) -->
            <div class="flex items-center gap-2.5 flex-1 w-0 min-w-0 overflow-hidden">
              <fa-icon [icon]="faHouse" class="text-sm flex-shrink-0" [ngClass]="{
              'text-gray-400': (currentDepth || 0) >= 1,
              'text-gray-700': (currentDepth || 0) < 1
            }"></fa-icon>

              <span class="font-medium text-sm hover:cursor-pointer whitespace-nowrap flex-shrink-0"
                    (click)="navigateToSpecificFolder(undefined, 0)" [ngClass]="{
              'text-gray-400': (currentDepth || 0) >= 1,
              'text-gray-700': (currentDepth || 0) < 1
            }">{{ headline }}</span>

              <!-- breadcrumb list: wie im Copy/Move (Ende bleibt sichtbar) -->
              <div class="flex items-center overflow-hidden flex-1 w-0 min-w-0">
                <div class="flex items-center overflow-hidden whitespace-nowrap min-w-0 w-full justify-end"
                     style="direction: rtl;">
                  <div style="direction: ltr;" class="flex items-center gap-2 min-w-0">
                    @for (i of [].constructor(currentDepth); track i; let j = $index) {
                      @if (this.parentDepthMap.has(j + 1)) {
                        <span class="flex items-center gap-2 min-w-0">
                          <fa-icon [icon]="faChevronRight" class="text-gray-400 flex-shrink-0 text-sm"></fa-icon>
                          <button type="button"
                                  (click)="navigateToSpecificFolder(this.parentDepthMap.get(j+1)!, j+1)"
                                  [tooltip]="this.parentDepthMap.get(j + 1)?.name ?? ''"
                                  class="font-medium text-sm truncate min-w-8 max-w-[400px]"
                                  [class]="this.parentDepthMap.has(j+2) ? 'text-gray-400' : 'text-gray-700'">
                            {{ this.parentDepthMap.get(j + 1)?.name }}
                          </button>
                        </span>
                      }
                    }
                  </div>
                </div>
              </div>
            </div>

            <!-- rechts: darf NICHT schrumpfen -->
            <div class="flex shrink-0 whitespace-nowrap">
              @if (selectedFiles.length == 0) {
                <span class="text-gray-500">{{ selectableFileCount() }} Dateien</span>
              }
              @if (selectedFiles.length != 0) {
                @let hiddenCount = hiddenSelectedFileCount();
                <span class="text-gray-500">{{ numberOfSelectedFilesWithoutFolder() }}
                  von {{ selectableFileCount() }} ausgewählt</span>
                @if (hiddenCount > 0) {
                  <span class="text-gray-500 ml-2">· {{ hiddenCount === 1 ? '1 ausgewählte Datei ist ausgeblendet' : hiddenCount + ' ausgewählte Dateien sind ausgeblendet' }}</span>
                }
              }

            </div>
          </div>



          @if (backButtonActivated) {
            <div class="flex pr-4">
              <bic-button (onClick)="backButtonClicked.emit()" buttonType="white">
                Zurück
                <fa-icon [icon]="faChevronLeft" iconLeft></fa-icon>
              </bic-button>
            </div>
          }
          <!-- TODO: Storage-Anzeige hier einfügen wenn aktiviert -->
          <div class="flex flex-grow min-w-0 w-full gap-4 justify-between">
            <div class="relative max-w-[400px] min-w-[160px] flex-grow">
              <!-- [value] gebunden, damit clearSearchTerm() beim Betreten eines Ordners auch im
                   Eingabefeld sichtbar wird. Bewusst NUR (valueChange), nicht zusaetzlich (input):
                   bic-input feuert beides, der doppelte Lauf traegt einmal einen leeren Wert. -->
              <bic-input (valueChange)="search($event)" [iconStart]="faMagnifyingGlass"
                         [placeholder]="'Suche nach...'"
                         [value]="searchTerm"
                         [showX]="true" id="simple-search">
              </bic-input>
            </div>

            <div class="flex flex-row gap-4 shrink-0 justify-end">
              <!-- Toolbar wirkt nur auf die sichtbare Auswahl; ausgeblendete Eintraege bleiben ausgewaehlt (#2770). -->
              @let visibleSelection = visibleSelectedFiles();
              @if (visibleSelection.length > 0 && !backButtonActivated) {
                <!-- Nur anzeigen, wenn ueberhaupt etwas Herunterladbares dabei ist: bei einer Auswahl
                     aus reinen Koordinationsmodellen gibt es keine Bytes und der ZIP-Download scheitert. -->
                @if (!calledFromCheck && hasDownloadableSelection()) {
                  @if (!permissionService.hasProjectPrivilege('PROJECT_VIEWER')) {

                    <div [tooltip]="'Keine Berechtigung'">
                      <bic-button [disabled]="true" buttonType="white" [iconOnly]="true">
                        <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
                      </bic-button>
                    </div>
                  
} @else {

                    <!-- iconOnly: waehrend des ZIP-Bauens zeigt bic-button nur den Spinner an Stelle des
                         Icons, die Breite bleibt (vorher zwei Symbole nebeneinander, Bericht 2427). -->
                    <bic-button (onClick)="downloadSelectedFiles()" buttonType="white" [iconOnly]="true"
                                [disabled]="hasPendingClassificationInSelection(visibleSelection)"
                                [loading]="downloadInProgress" loadingPosition="left"
                                [tooltip]="hasPendingClassificationInSelection(visibleSelection) ? 'Klassifizierung läuft noch' : 'Herunterladen'">
                      <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
                    </bic-button>
                  
}
                  
                }
                @if (!calledFromCheck && visibleSelection.length === 1 && (visibleSelection[0]?.fileType === ProjectFile.FileTypeEnum.PDF || visibleSelection[0]?.fileType === ProjectFile.FileTypeEnum.IFC || visibleSelection[0]?.fileType === ProjectFile.FileTypeEnum.COORDINATION)) {
                  <bic-button
                    (onClick)="open()"
                    buttonType="white"
                    [iconOnly]="true"
                    [disabled]="visibleSelection[0]?.fileType === ProjectFile.FileTypeEnum.IFC && !hasFragments(visibleSelection[0])"
                    [tooltip]="'Öffnen'"
                  >
                    <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
                  </bic-button>
                }
                <!-- Gesperrt statt versteckt, solange eine der gewaehlten IFC-Dateien noch analysiert
                     wird: ein Koordinationsmodell ueberlagert die Fragments seiner Dateien, und ohne
                     die entsteht zwar das Modell, der Viewer bleibt aber weiss. Der Tooltip sagt,
                     worauf zu warten ist - vorher war dieser Knopf der einzige, der waehrend der
                     Analyse noch ging, waehrend alles andere an der Zeile ausgegraut war. -->
                @if (getSelectedIfcFiles().length >= 2 && !calledFromCheck) {
                  <bic-button (onClick)="openCoordinationModel()" buttonType="white" [iconOnly]="true"
                              [disabled]="coordinationBlockedReason() !== null"
                              [tooltip]="coordinationBlockedReason() ?? 'Koordinationsmodell öffnen'">
                    <fa-icon [icon]="faLayerGroup" iconLeft></fa-icon>
                  </bic-button>
                }
                @if (getSelectedIfcFiles().length >= 1 && permissionService.hasProjectPrivilege('PROJECT_FILE_EDIT') && !calledFromCheck) {
                  <bic-button (onClick)="createCoordinationModelFile()" buttonType="white" [iconOnly]="true"
                              [disabled]="coordinationBlockedReason() !== null"
                              [tooltip]="coordinationBlockedReason() ?? 'Koordinationsmodell erstellen'">
                    <fa-icon [icon]="faLayerGroupPlus" iconLeft></fa-icon>
                  </bic-button>
                }
                @if (!calledFromCheck) {
                  @if (permissionService.hasProjectPrivilege('PROJECT_FILE_EDIT')) {
                    <!-- disabled statt versteckt: der Button soll nicht springen, waehrend ein Upload
                         laeuft - der Tooltip nennt den Grund. -->
                    <bic-button (onClick)="moveFile(undefined)" [disabled]="selectionHasMirrored() || hasPendingUploadInSelection(visibleSelection) || hasPendingClassificationInSelection(visibleSelection)" [tooltip]="selectionHasMirrored() ? mirroredHint : (hasPendingUploadInSelection(visibleSelection) ? 'Upload läuft noch' : (hasPendingClassificationInSelection(visibleSelection) ? 'Klassifizierung läuft noch' : 'Verschieben'))"
                                buttonType="white"
                                [iconOnly]="true">
                      <fa-icon [icon]="faArrowsUpDownLeftRight" iconLeft></fa-icon>
                    </bic-button>
                    <bic-button (onClick)="copyFile(undefined)" [disabled]="hasPendingUploadInSelection(visibleSelection) || hasPendingClassificationInSelection(visibleSelection)" [tooltip]="hasPendingUploadInSelection(visibleSelection) ? 'Upload läuft noch' : (hasPendingClassificationInSelection(visibleSelection) ? 'Klassifizierung läuft noch' : 'Kopieren')"
                                buttonType="white"
                                [iconOnly]="true">
                      <fa-icon [icon]="faCopy" iconLeft></fa-icon>
                    </bic-button>
                  }
                  <!-- Sammel-Neustart. Erscheint nur, wenn in der Auswahl ueberhaupt etwas zu
                       wiederholen ist - ein Knopf, der meistens nichts tut, waere hier nur im Weg.
                       Ordner zaehlen mit: wer einen Ordner mit 40 gescheiterten Dateien anwaehlt,
                       soll nicht vierzig Mal klicken muessen. -->
                  @if (permissionService.hasProjectPrivilege('PROJECT_FILE_EDIT') && retryableCountInSelection() > 0) {
                    <bic-button (onClick)="retrySelectedClassifications()" buttonType="white"
                                [iconOnly]="true"
                                [tooltip]="retryableCountInSelection() === 1
                                  ? 'Klassifizierung erneut versuchen'
                                  : retryableCountInSelection() + ' Dateien erneut klassifizieren'">
                      <fa-icon [icon]="faArrowsRotate" iconLeft></fa-icon>
                    </bic-button>
                  }
                  @if (permissionService.hasProjectPrivilege('PROJECT_FILE_DELETE')) {
                    <bic-button (onClick)="deleteFile()" buttonType="white" [iconOnly]="true"
                                [disabled]="selectionHasMirrored()" [tooltip]="selectionHasMirrored() ? mirroredHint : 'Löschen'">
                      <fa-icon [icon]="faTrash" class="text-red" iconLeft></fa-icon>
                    </bic-button>
                  }
                }
              }


              <!-- Verknuepfter Ordner: dezenter Sync-Status mit Aktionen (Figma Screens 05/05b, BIC-Frontend#2720) -->
              @if (currentLink && !calledFromCheck) {
                <bic-button [bicDropdownTrigger]="syncMenuDropdown" buttonType="white" [tooltip]="syncTooltip">
                  @if (currentLinkSyncing) {
                    <fa-icon [icon]="faArrowsRotate" [spin]="true" iconLeft></fa-icon>
                  } @else if (currentLink.status === 'ERROR' || currentLink.status === 'PAUSED') {
                    <fa-icon [icon]="faTriangleExclamation" class="text-red" iconLeft></fa-icon>
                  } @else {
                    <fa-icon [icon]="faArrowsRotate" iconLeft></fa-icon>
                  }
                  <span>{{ syncLabel }}</span>
                  <fa-icon [icon]="faChevronDown" class="pl-1"></fa-icon>
                </bic-button>
                <bic-dropdown #syncMenuDropdown [dropdownPlacement]="'bottom-end'" class="contents">
                  @if (currentLinkSyncing) {
                    <bic-dropdown-element (click)="openSyncProgress()">
                      <fa-icon [icon]="faBarsProgress" iconLeft></fa-icon><span>Fortschritt anzeigen</span>
                    </bic-dropdown-element>
                  }
                  @if (permissionService.hasProjectPrivilege('PROJECT_FILE_EDIT') && !currentLinkSyncing) {
                    <bic-dropdown-element (click)="syncCurrentLink()">
                      <fa-icon [icon]="faArrowsRotate" iconLeft></fa-icon><span>Jetzt synchronisieren</span>
                    </bic-dropdown-element>
                  }
                  @if (currentLink.folderWebUrl) {
                    <bic-dropdown-element (click)="openExternal(currentLink.folderWebUrl)">
                      <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon><span>In SharePoint öffnen</span>
                    </bic-dropdown-element>
                  }
                  @if (permissionService.hasProjectPrivilege('PROJECT_FILE_EDIT')) {
                    <bic-dropdown-element (click)="unlinkCurrentLink()">
                      <fa-icon [icon]="faLinkSlash" iconLeft></fa-icon><span>Verknüpfung lösen</span>
                    </bic-dropdown-element>
                  }
                </bic-dropdown>
              }

              @if (filterAndContextButtonActivated) {
                <app-bic-filter (filtersChange)="onFiltersChange($event)"
                                [filtersConfig]="filterConfig"></app-bic-filter>
              }

              <bic-button (onClick)="showSelectedInfo()" buttonType="white">
                <fa-icon [icon]="faInfoCircle" iconLeft></fa-icon>
                <span>Info</span>
              </bic-button>


            </div>
          </div>

        </div>
        @if (classifyingCount > 0 && !calledFromCheck) {
          <app-classification-progress-banner [count]="classifyingCount"></app-classification-progress-banner>
        }
        <div (dragleave)="onDragLeave($event)"
             (dragover)="onDragOver($event)"
             (drop)="onDrop($event)"
             class="flex flex-col w-full item-center justify-between h-full overflow-hidden relative">
          @if (isDragOver) {
            <!-- z-[110]: die sticky Tabellen-Kopfzeile (cdk-header-row[sticky]) bekommt von CDK per Inline-Style
                 z-index:100 (siehe StickyStyler._getCalculatedZIndex), läge also sonst über diesem Overlay. -->
            <div
              class="absolute inset-0 z-[110] flex items-center justify-center bg-green-50/90 border-2 border-dashed border-green-400 rounded-lg pointer-events-none">
            <span class="text-sm font-medium text-green-700">Dateien oder Ordner hier ablegen</span>
            </div>
          }
          @if (loading) {
            <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
              <div class="flex flex-row items-center gap-2">
                <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                <span class="text-sm font-medium text-gray-500">Dateien werden geladen...</span>
              </div>
            </div>
          } @else if (this.filteredData.length == 0 && hasActiveSearchOrFilter) {
            <app-empty-state [icon]="faMagnifyingGlass"
                             [message]="searchTerm.trim() ? 'Keine Dateien gefunden für „' + searchTerm.trim() + '“.' : 'Keine Dateien entsprechen den aktiven Filtern.'">
              @if (searchTerm.trim()) {
                <bic-button buttonType="white" (click)="resetSearch()">Suche zurücksetzen</bic-button>
              }
            </app-empty-state>
          } @else if (this.filteredData.length == 0 && currentLink) {
            <!-- Leerer verknuepfter Ordner: Inhalt kommt nur aus der Quelle (BIC-Frontend#2720) -->
            <app-empty-state [icon]="faArrowsRotate"
                             [message]="currentLink.status === 'INITIAL_SYNC' ? 'Der erste Abgleich mit SharePoint läuft. Die Dateien erscheinen hier nach und nach.' : 'In diesem Ordner liegen in SharePoint keine übernommenen Dateien.'">
            </app-empty-state>
          } @else if (this.filteredData.length == 0) {
            <app-empty-state [icon]="faSquareDashedCirclePlus"
                             message="Dateien oder Ordner hier ablegen oder hochladen.">
              @if (!calledFromCheck) {
                @if (writeBlockedReason) {
<div [tooltip]="writeBlockedReason">
                  <bic-button [bicDropdownTrigger]="emptyUploadMenuDropdown" [disabled]="true" buttonType="white">Hochladen
                    <fa-icon [icon]="faArrowUpFromBracket" iconLeft></fa-icon>
                  </bic-button>
                </div>
}
                @if (!writeBlockedReason) {
<bic-button [bicDropdownTrigger]="emptyUploadMenuDropdown" buttonType="white">Hochladen
                  <fa-icon [icon]="faArrowUpFromBracket" iconLeft></fa-icon>
                </bic-button>
}
                <bic-dropdown #emptyUploadMenuDropdown>
                  <bic-dropdown-element (click)="$event.stopPropagation(); emptyUploadInput.click()">
                    <div class="flex flex-row text-sm gap-3 text-gray-700 items-center">
                      <fa-icon class="text-gray-700 w-4" [icon]="faFile"></fa-icon>
                      <span>Dateien</span>
                    </div>
                  </bic-dropdown-element>
                  <bic-dropdown-element (click)="$event.stopPropagation(); emptyUploadFolderInput.click()">
                    <div class="flex flex-row text-sm gap-3 text-gray-700 items-center">
                      <fa-icon class="text-gray-700 w-4" [icon]="faFolderOpen"></fa-icon>
                      <span>Ordner</span>
                    </div>
                  </bic-dropdown-element>
                  <bic-dropdown-element (click)="$event.stopPropagation(); linkSourceFolder()">
                    <div class="flex flex-row text-sm gap-3 text-gray-700 items-center">
                      <img src="assets/connectors/sharepoint.svg" alt="" class="w-4 h-4">
                      <span class="whitespace-nowrap">Mit SharePoint verknüpfen</span>
                    </div>
                  </bic-dropdown-element>
                </bic-dropdown>
                <input #emptyUploadInput (change)="openUploadSelection($event)"
                       accept=".pdf, .ifc, .xlsx, .pptx, .docx" hidden multiple type="file">
                <input #emptyUploadFolderInput (change)="openUploadSelection($event, true)" directory hidden
                       type="file" webkitdirectory>
              }
            </app-empty-state>

          } @else if (this.filteredData.length > 0) {
            <!-- overflow-x-auto: vorher overflow-x-hidden. Die Zeilen waren auf eine feste Mindestbreite
                 gebunden, alles darueber wurde stumm abgeschnitten - inklusive der Kontextmenue-Spalte. -->
            <div class="flex w-full h-full overflow-x-auto overflow-y-hidden">
              <cdk-table [dataSource]="filteredData"
                         [trackBy]="trackRow"
                         class="w-full h-full text-sm text-left text-gray-500 overflow-y-auto"
                         id="tableContainer">
                <ng-container cdkColumnDef="selectionFields">
                  <cdk-header-cell *cdkHeaderCellDef [style.min-width]="columnWidths[0]" [style.width]="columnWidths[0]"
                                  [style.flex]="'0 0 auto'" class="justify-center">
                    <div class="flex items-center w-full p-4">
                      <input (change)="onSelectAllChange($event)" [checked]="areAllRowsSelected()"
                             [indeterminate]="areSomeRowsSelected() && !areAllRowsSelected()"
                             id="checkbox-all"
                             type="checkbox"
                             [class]="dark ? 'bg-gray-700 border-gray-500 ring-offset-gray-800': 'bg-white border-gray-400'"
                             class="w-4 h-4 rounded text-green-600 checked:bg-green indeterminate:bg-green indeterminate:hover:bg-green focus:ring-[none] ">
                      <label for="checkbox-all" class="sr-only">checkbox</label>
                    </div>
                  </cdk-header-cell>
                  <cdk-cell *cdkCellDef="let element" [style.min-width]="columnWidths[0]"
                            [style.width]="columnWidths[0]" [style.flex]="'0 0 auto'" class="justify-center">
                    <div class="flex items-center w-12 p-4">
                      <!-- Dauerhaft sichtbar: die Checkbox war zuvor nur bei Hover/Auswahl im DOM. -->
                      <input [id]="'checkbox-row-' + element.id" type="checkbox"
                             (click)="onRowCheckboxClick(element, $event)"
                             [checked]="isElementInSelectedFiles(element)"
                             [indeterminate]="hasElementSelectedChildren(element)"
                             [class]="dark ? 'bg-gray-700 border-gray-500': 'bg-white border-gray-400'"
                             class="w-4 h-4 rounded text-green-600 checked:bg-green focus:ring-[none]">
                      <label [for]="'checkbox-row-' + element.id" class="sr-only">checkbox</label>
                    </div>

                  </cdk-cell>

                </ng-container>


                <ng-container cdkColumnDef="icon">
                  <cdk-header-cell *cdkHeaderCellDef [style.min-width]="columnWidths[1]" [style.width]="columnWidths[1]"
                                  [style.flex]="'0 0 auto'" class="justify-center">
                    <div class="flex w-full h-full p-4 justify-center">
                      <fa-icon [class]="dark ? 'text-gray-700': 'text-gray-50'" [icon]="faFile"
                               class=" text-lg"></fa-icon>
                    </div>
                  </cdk-header-cell>

                  <cdk-cell *cdkCellDef="let element" [style.min-width]="columnWidths[1]"
                            [style.width]="columnWidths[1]" [style.flex]="'0 0 auto'" class="justify-center">
                    <div class="flex h-full justify-center" [class]="!element.isFolder ? 'px-4' : 'px-3'">
                      <!-- Dateien mit Dokumentenklasse. Das Koordinationsmodell hat KEINE Klasse und
                           bekommt darum sein eigenes Icon (unten) - vorher stand dessen fa-icon in
                           diesem span, dessen *ngIf COORDINATION gerade ausschliesst: die Zelle blieb
                           bei Koordinationsmodellen komplett leer. -->
                      @if (!element.isFolder && element.fileType !== ProjectFile.FileTypeEnum.COORDINATION) {
<span
                            [tooltipSubtext]="element.documentClassTitles?.length ? element.documentClassTitles.join(', ') : (element.fileStatus === ProjectFile.FileStatusEnum.PROCESSING ? 'Zuordnung läuft' : (element.fileStatus === ProjectFile.FileStatusEnum.READY ? 'Sonstige Dokumente' : ''))"
                            tooltip="Dokumentenklasse">
                        <fa-icon [icon]="faFile" class="text-gray-300 text-lg"></fa-icon>
                      </span>
}
                      @if (!element.isFolder && element.fileType === ProjectFile.FileTypeEnum.COORDINATION) {
<fa-icon
                               [icon]="faLayerGroup" class="text-gray-300 text-lg"
                               tooltip="Koordinationsmodell"></fa-icon>
}
                      @if (element.isFolder && linkByTargetFolder.has(element.id)) {
                        <!-- Zielordner eines verknuepften SharePoint-Ordners (Figma icon/folder-sync) -->
                        <span class="hover:cursor-pointer" role="button" aria-label="Open folder"
                              (click)="$event.stopPropagation(); navigateIntoFolder(element)">
                          <app-folder-sync-icon sizeClass="text-lg" folderClass="text-gray-300"
                                                [title]="'Mit SharePoint synchronisiert: ' + linkByTargetFolder.get(element.id)!.folderPath"></app-folder-sync-icon>
                        </span>
                      } @else if (element.isFolder) {
<fa-icon
                        class="text-gray-300 text-lg hover:cursor-pointer"
                        [icon]="faFolderOpen"
                        (click)="$event.stopPropagation(); navigateIntoFolder(element)" role="button"
                        aria-label="Open folder"></fa-icon>
}
                    </div>
                  </cdk-cell>

                </ng-container>


                @for (col of columns; track col; let i = $index) {

                  @if (!(contextMenu && i === columns.length - 1) && !(selectionFields && i === 0) && !(icon && i === 1) && !(columns[i] === 'createdBy')) {
<ng-container cdkColumnDef="{{col}}"
                               >
                    <cdk-header-cell *cdkHeaderCellDef (click)="sortData(col, columnNames[i], columnTypes[i])"
                                     [style.width]="columnLayout(col, i).width"
                                     [style.min-width]="columnLayout(col, i).minWidth"
                                     [style.flex]="columnLayout(col, i).flex"
                                     [ngClass]="{
                                       'justify-start': columnAlignments[i] === 'start',
                                       'justify-center': columnAlignments[i] === 'center',
                                       'justify-end': columnAlignments[i] === 'end',
                                       '!hidden': isBreakpointHiddenColumn(col),
                                       'xl:!flex': isBreakpointHiddenColumn(col),
                                       'xl:!w-[120px]': isBreakpointHiddenColumn(col),
                                       '2xl:!w-[200px]': isBreakpointHiddenColumn(col),
                                       'flex': !isBreakpointHiddenColumn(col)
                                     }"
                                     class="flex-row text-xs text-gray-500 items-center p-4 gap-2 whitespace-nowrap cursor-pointer">
                      {{ columnNames[i] }}
                      @if (columnNames[i] != '' && (sortedColumn != columnNames[i] || sortedColumn == columnNames[i] && sortedDirection == '')) {

                        <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                      
}
                      @if (sortedColumn == columnNames[i] && sortedDirection != '') {

                        @if (sortedDirection == 'asc') {

                          <fa-icon [icon]="faSortUp" class="text-gray-400"></fa-icon>
                        
}
                        @if (sortedDirection == 'desc') {

                          <fa-icon [icon]="faSortDown" class="text-gray-400"></fa-icon>
                        
}
                      
}
                    </cdk-header-cell>

                    <!-- text type -->
                    @if (columnTypes[i] == 'text') {

                      <cdk-cell *cdkCellDef="let element"
                                [style.width]="columnLayout(col, i).width"
                                [style.min-width]="columnLayout(col, i).minWidth"
                                [style.flex]="columnLayout(col, i).flex"
                                [ngClass]="{
                                  'justify-start': columnAlignments[i] === 'start',
                                  'justify-center': columnAlignments[i] === 'center',
                                  'justify-end': columnAlignments[i] === 'end',
                                  '!hidden': isBreakpointHiddenColumn(col),
                                  'xl:!flex': isBreakpointHiddenColumn(col),
                                  'xl:!w-[120px]': isBreakpointHiddenColumn(col),
                                  '2xl:!w-[200px]': isBreakpointHiddenColumn(col),
                                  'flex': !isBreakpointHiddenColumn(col)
                                }"
                                class="flex-row text-gray p-4 items-center whitespace-nowrap">
                        @if (columns[i] === 'fileType') {

                          @if (element?.isFolder) {

                            Ordner
                          
} @else {

                            {{ element[col] | fileType }}
                          
}
                          
                        
}
                        @if (columns[i] !== 'fileType') {

                    <span [tooltip]="element[col]"
                          class="truncate overflow-hidden whitespace-nowrap">{{ element[col] }}</span>
                        
}

                      </cdk-cell>
                    
}

                    <!-- status type -->
                    @if (columnTypes[i] == 'status') {

                      <cdk-cell *cdkCellDef="let element"
                                [style.width]="columnLayout(col, i).width"
                                [style.min-width]="columnLayout(col, i).minWidth"
                                [style.flex]="columnLayout(col, i).flex"
                                [ngClass]="{
                                  'justify-start': columnAlignments[i] === 'start',
                                  'justify-center': columnAlignments[i] === 'center',
                                  'justify-end': columnAlignments[i] === 'end',
                                  '!hidden': isBreakpointHiddenColumn(col),
                                  'xl:!flex': isBreakpointHiddenColumn(col),
                                  'xl:!w-[120px]': isBreakpointHiddenColumn(col),
                                  '2xl:!w-[200px]': isBreakpointHiddenColumn(col),
                                  'flex': !isBreakpointHiddenColumn(col)
                                }"
                                class="flex-row p-4 items-center">


                        <!-- Genau EIN Kreis pro Zeile. Vorher entschieden das fuenf unabhaengige
                             *ngIf-Ausdruecke, die sich gegenseitig nicht ausschlossen (eine IFC-Datei in
                             PROCESSING zeigte "Analyse laeuft" und "Bereit" gleichzeitig) und deren
                             Tooltips hartcodiert waren - daher der Widerspruch zum Detailpanel.
                             Die Entscheidung liegt jetzt in statusCircle(); die Texte kommen aus
                             FILE_STATUS_LABELS, derselben Quelle wie die fileStatus-Pipe. -->
                        @switch (statusCircle(element)) {
                          @case ('uploading') {
                            <files-status-circle
                              [state]="FileCircleState.START"
                              [tooltip]="statusCircleTooltip(element, 'uploading')"
                              [value]="uploadProgressOf(element)"
                              class="w-6"></files-status-circle>
                          }
                          @case ('analysing') {
                            <files-status-circle
                              [state]="FileCircleState.ANALYSING"
                              [tooltip]="statusCircleTooltip(element, 'analysing')"
                              class="w-6 text-gray-300"></files-status-circle>
                          }
                          @case ('ready') {
                            <files-status-circle
                              [state]="FileCircleState.READY"
                              [tooltip]="statusCircleTooltip(element, 'ready')"
                              class="w-6 text-green-500"></files-status-circle>
                          }
                          @case ('ifcUnclassified') {
                            <files-status-circle
                              [state]="FileCircleState.ERROR"
                              [tooltip]="statusCircleTooltip(element, 'ifcUnclassified')"
                              class="w-6 text-red-500"></files-status-circle>
                          }
                          @case ('stalled') {
                            <!-- Klassifizierung reagiert nicht mehr (verlorenes SSE, aufgegebener
                                 IFC-Poll): Klick startet sie neu, statt endlos weiterzudrehen. -->
                            <span (click)="onErrorCircleClick($event, element)" class="cursor-pointer">
                              <files-status-circle
                                [state]="FileCircleState.ERROR"
                                [tooltip]="statusCircleTooltip(element, 'stalled')"
                                class="w-6 text-red-500"></files-status-circle>
                            </span>
                          }
                          @case ('error') {
                            <span (click)="onErrorCircleClick($event, element)"
                                  [class.cursor-pointer]="isRetryableCircle(element, 'error')">
                              <files-status-circle
                                [state]="FileCircleState.ERROR"
                                [tooltip]="statusCircleTooltip(element, 'error')"
                                class="w-6 text-red-500"></files-status-circle>
                            </span>
                          }
                        }

                      </cdk-cell>
                    
}


                    <!-- date type -->
                    @if (columnTypes[i] == 'date') {

                      <cdk-cell *cdkCellDef="let element"
                                [style.width]="columnLayout(col, i).width"
                                [style.min-width]="columnLayout(col, i).minWidth"
                                [style.flex]="columnLayout(col, i).flex"
                                [ngClass]="{
                                  'justify-start': columnAlignments[i] === 'start',
                                  'justify-center': columnAlignments[i] === 'center',
                                  'justify-end': columnAlignments[i] === 'end',
                                  '!hidden': isBreakpointHiddenColumn(col),
                                  'xl:!flex': isBreakpointHiddenColumn(col),
                                  'xl:!w-[120px]': isBreakpointHiddenColumn(col),
                                  '2xl:!w-[200px]': isBreakpointHiddenColumn(col),
                                  'flex': !isBreakpointHiddenColumn(col)
                                }"
                                class="flex-row p-4 items-center text-gray whitespace-nowrap">
                        {{ element[col] | date: 'dd.MM.yyyy HH:mm' }}
                      </cdk-cell>
                    
}

                    <!-- filesize type -->
                    @if (columnTypes[i] == 'filesize') {


                      <cdk-cell *cdkCellDef="let element"
                                [style.width]="columnLayout(col, i).width"
                                [style.min-width]="columnLayout(col, i).minWidth"
                                [style.flex]="columnLayout(col, i).flex"
                                [ngClass]="{
                                  'justify-start': columnAlignments[i] === 'start',
                                  'justify-center': columnAlignments[i] === 'center',
                                  'justify-end': columnAlignments[i] === 'end',
                                  '!hidden': isBreakpointHiddenColumn(col),
                                  'xl:!flex': isBreakpointHiddenColumn(col),
                                  'xl:!w-[120px]': isBreakpointHiddenColumn(col),
                                  '2xl:!w-[200px]': isBreakpointHiddenColumn(col),
                                  'flex': !isBreakpointHiddenColumn(col)
                                }"
                                class="flex-row p-4 items-center whitespace-nowrap">
                        @if (calculateSizeInMB(element[col]) > 1024) {

                          @if (calculateSizeInGB(element[col]) < 10) {

                            {{ calculateSizeInGB(element[col]) | number: '.0-2' }} GB
                          
}
                          @if (calculateSizeInGB(element[col]) >= 10) {

                            {{ calculateSizeInGB(element[col]) | number: '.0-1' }} GB
                          
}

                        
}
                        @if (calculateSizeInMB(element[col]) <= 1024) {

                          @if (calculateSizeInMB(element[col]) < 10) {

                            {{ calculateSizeInMB(element[col]) | number: '.0-2' }} MB
                          
}
                          @if (calculateSizeInMB(element[col])  >= 10) {

                            {{ calculateSizeInMB(element[col]) | number: '.0-1' }} MB
                          
}
                        
}
                      </cdk-cell>
                    
}


                  </ng-container>
}
                
}

                <!-- Hidden createdBy column definition (for filtering only) -->
                <ng-container cdkColumnDef="createdBy">
                  <cdk-header-cell *cdkHeaderCellDef class="hidden"></cdk-header-cell>
                  <cdk-cell *cdkCellDef="let element" class="hidden">
                    {{ element.createdBy || '-' }}
                  </cdk-cell>
                </ng-container>

                @if (contextMenu) {
<ng-container cdkColumnDef="contextMenu">

                  <cdk-header-cell *cdkHeaderCellDef class="w-12 shrink-0 justify-end">
                    <div class="flex justify-end pr-4">
                      <fa-icon [class]="dark ? 'text-gray-700': 'text-gray-50'" [icon]="faEllipsisVertical"
                               class="px-1.5 text-base"></fa-icon>
                    </div>
                  </cdk-header-cell>

                  <cdk-cell *cdkCellDef="let element" class="w-12 shrink-0 justify-end"
                            (click)="$event.stopPropagation()">

                    <div [bicDropdownTrigger]="contextMenuDropdown"
                         (click)="$event.stopPropagation(); highlightedRow = element"
                         class="flex justify-end hover:cursor-pointer pr-4 ml-auto">
                      <fa-icon [icon]="faEllipsisVertical"
                               class="text-gray-900 px-1.5 text-base"></fa-icon>
                    </div>
                    <bic-dropdown #contextMenuDropdown (close)="highlightedRow = null">
                      <!-- Ein Koordinationsmodell ist nur eine Verknuepfung mehrerer IFC-Dateien und hat
                           selbst keine Bytes: "Herunterladen" lief dort zwangslaeufig auf einen Fehler. -->
                      @if (element.fileType !== ProjectFile.FileTypeEnum.COORDINATION) {
                        @if (!permissionService.hasProjectPrivilege('PROJECT_VIEWER')) {

                          <div [tooltip]="'Keine Berechtigung'">
                            <bic-dropdown-element [disabled]="true">
                              <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
                              <span class="text-gray-400">Herunterladen</span>
                            </bic-dropdown-element>
                          </div>
                        
} @else {

                          @if (hasPendingClassificationInSelection([element])) {
                            <bic-dropdown-element [disabled]="true" [tooltip]="'Klassifizierung läuft noch'">
                              <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
                              <span class="text-gray-400">Herunterladen (nicht verfügbar)</span>
                            </bic-dropdown-element>
                          } @else {
                          <bic-dropdown-element (click)="$event.stopPropagation(); downloadFile(element)"
                                                [disabled]="downloadingFileId === element.id">
                            <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
                            <span>Herunterladen</span>
                          </bic-dropdown-element>
                          }
                        
}
                        
                      }

                      @if (element.fileType == ProjectFile.FileTypeEnum.PDF || element.fileType == ProjectFile.FileTypeEnum.IFC || element.fileType == ProjectFile.FileTypeEnum.FOLDER || element.fileType == ProjectFile.FileTypeEnum.COORDINATION) {
                        @if (!(element.fileType == ProjectFile.FileTypeEnum.IFC && !hasFragments(element))) {
                          <bic-dropdown-element (click)="$event.stopPropagation(); open(element)">
                            <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
                            <span>Öffnen</span>
                          </bic-dropdown-element>
                        } @else {
                          <bic-dropdown-element
                            [disabled]="true"
                            [tooltip]="'Diese IFC-Datei muss zuerst klassifiziert werden. Bitte nutzen Sie die Option &quot;Klassifizierung erneut versuchen&quot;'">
                            <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
                            <span class="text-gray-400">Öffnen (nicht verfügbar)</span>
                          </bic-dropdown-element>
                        }
                      }

                      <bic-dropdown-element
                        (click)="$event.stopPropagation(); showInfo(element); contextMenuDropdown.hide()">
                        <fa-icon [icon]="faCircleInfo" iconLeft></fa-icon>
                        <span>Info</span>
                      </bic-dropdown-element>
                      @if (element.externalWebUrl) {
                        <bic-dropdown-element
                          (click)="$event.stopPropagation(); openExternal(element.externalWebUrl); contextMenuDropdown.hide()">
                          <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
                          <span>In SharePoint öffnen</span>
                        </bic-dropdown-element>
                      }
                      @if (permissionService.hasProjectPrivilege('PROJECT_FILE_EDIT')) {
                        @if (element.fileType == ProjectFile.FileTypeEnum.COORDINATION) {
                          @if (!calledFromCheck) {
<bic-dropdown-element
                            (click)="$event.stopPropagation(); editCoordinationModel(element); contextMenuDropdown.hide()"
                           >
                            <fa-icon [icon]="faLayerGroup" iconLeft></fa-icon>
                            <span>Verknüpfte Dateien bearbeiten</span>
                          </bic-dropdown-element>
}
                        }
                        <!-- canRetryIfcClassification() statt der blossen Fragments-Pruefung: waehrend
                             Upload und Analyse hat die Datei noch keine Fragments, ein Klick hier
                             startete also eine zweite Klassifizierung neben der laufenden und brach
                             sie damit ab. Und im Status ERROR bietet der Block weiter unten denselben
                             Text an - eine IFC-Datei ohne Fragments erfuellte beides und hatte den
                             Eintrag doppelt im Menue. -->
                        @if (canRetryIfcClassification(element)) {
                          @if (!calledFromCheck) {
<bic-dropdown-element
                            (click)="$event.stopPropagation(); reclassifyFile(element); contextMenuDropdown.hide()"
                           >
                            <fa-icon [icon]="faArrowsRotate" iconLeft></fa-icon>
                            <span>Klassifizierung erneut versuchen</span>
                          </bic-dropdown-element>
}
                        }
                        <!-- Koordinationsmodelle werden nicht klassifiziert - sie haben keinen Inhalt,
                             dem eine Dokumentenklasse zugeordnet werden koennte. -->
                        @if (!element.isFolder && element.fileStatus === ProjectFile.FileStatusEnum.READY
                        && element.fileType !== ProjectFile.FileTypeEnum.COORDINATION) {
                          @if (!calledFromCheck) {
<bic-dropdown-element
                            (click)="$event.stopPropagation(); reclassifyDocumentClass(element); contextMenuDropdown.hide()"
                           >
                            <!-- faTags statt faArrowsRotate: dieser Eintrag weist eine Dokumentenklasse
                                 zu und ist etwas anderes als die beiden "Klassifizierung erneut
                                 versuchen"-Einträge, die dasselbe Icon trugen. -->
                            <fa-icon [icon]="faTags" iconLeft></fa-icon>
                            <span>{{ fileHasNoDocumentClass(element) ? 'Dokumentenklasse zuweisen' : 'Dokumentenklasse neu klassifizieren' }}</span>
                          </bic-dropdown-element>
}
                        }
                        <!-- Nach genug Fehlschlaegen wird der Punkt nicht mehr angeboten, sondern
                             durch den Hinweis ersetzt, was wirklich hilft. Ein Knopf, der jedes Mal
                             denselben Fehler produziert, ist schlechter als keiner - und jeder Klick
                             kostet einen vollen Lauf durch die KI-Dienste. -->
                        @if (!element.isFolder && element.fileStatus === ProjectFile.FileStatusEnum.ERROR) {
                          @if (!isClassificationExhausted(element)) {
                            @if (!calledFromCheck) {
<bic-dropdown-element
                              (click)="$event.stopPropagation(); retryClassification(element); contextMenuDropdown.hide()"
                             >
                              <fa-icon [icon]="faArrowsRotate" iconLeft></fa-icon>
                              <span>Klassifizierung erneut versuchen</span>
                            </bic-dropdown-element>
}
                          } @else {
                            @if (!calledFromCheck) {
<bic-dropdown-element
                              [disabled]="true"
                              [tooltip]="element.errorReason ?? 'Diese Datei lässt sich nicht klassifizieren.'"
                             >
                              <fa-icon [icon]="faArrowsRotate" iconLeft></fa-icon>
                              <span class="text-gray-400">Bitte löschen und erneut hochladen</span>
                            </bic-dropdown-element>
}
                          }
                        }
                        <!-- Solange zu dieser Zeile (oder in diesem Ordner) ein Upload laeuft, sind
                             Kopieren und Verschieben gesperrt: die Upload-Jobs tragen die alte
                             parentId und Zeilen ohne Server-ID fielen beim Verschieben lautlos raus. -->
                        @if (!calledFromCheck) {
                          @if (!hasPendingUploadInSelection([element]) && !hasPendingClassificationInSelection([element])) {
                            <bic-dropdown-element (click)="$event.stopPropagation(); copyFile(element)">
                              <fa-icon [icon]="faCopy" iconLeft></fa-icon>
                              <span>Kopieren</span>
                            </bic-dropdown-element>

                            <!-- Gespiegelte Dateien (BIC-Frontend#2720): Kopieren ergibt eine normale Datei,
                                 Verschieben, Umbenennen und Loeschen laufen nur in der Quelle. -->
                            @if (element.sourceLinkId) {
                              <bic-dropdown-element [disabled]="true" [tooltip]="mirroredHint">
                                <fa-icon [icon]="faArrowsUpDownLeftRight" iconLeft></fa-icon>
                                <span class="text-gray-400">Verschieben (in SharePoint)</span>
                              </bic-dropdown-element>
                            } @else {
                              <bic-dropdown-element (click)="$event.stopPropagation(); moveFile(element)">
                                <fa-icon [icon]="faArrowsUpDownLeftRight" iconLeft></fa-icon>
                                <span>Verschieben</span>
                              </bic-dropdown-element>
                            }
                          } @else {
                            <bic-dropdown-element [disabled]="true" [tooltip]="hasPendingUploadInSelection([element]) ? 'Upload läuft noch' : 'Klassifizierung läuft noch'">
                              <fa-icon [icon]="faCopy" iconLeft></fa-icon>
                              <span class="text-gray-400">Kopieren (nicht verfügbar)</span>
                            </bic-dropdown-element>

                            <bic-dropdown-element [disabled]="true" [tooltip]="hasPendingUploadInSelection([element]) ? 'Upload läuft noch' : 'Klassifizierung läuft noch'">
                              <fa-icon [icon]="faArrowsUpDownLeftRight" iconLeft></fa-icon>
                              <span class="text-gray-400">Verschieben (nicht verfügbar)</span>
                            </bic-dropdown-element>
                          }
                        }

                        <!-- Waehrend des Uploads gesperrt: die Zeile hat serverseitig noch keine
                             (bzw. nur eine Dummy-) ID. Der Rename-Call lief damit ins Leere, der
                             lokale Name blieb aber stehen - der Ordner tauchte nach dem naechsten
                             Laden unter dem alten Namen wieder auf. Zwei Varianten wie bei "Öffnen":
                             die gesperrte bindet gar kein (click), sonst feuerte der Host-Listener
                             trotz [disabled] weiter. -->
                        @if (!calledFromCheck) {
                          @if (element.sourceLinkId) {
                            <bic-dropdown-element [disabled]="true" [tooltip]="mirroredHint">
                              <fa-icon [icon]="faPenToSquare" iconLeft></fa-icon>
                              <span class="text-gray-400">Umbenennen (in SharePoint)</span>
                            </bic-dropdown-element>
                          } @else if (!isPendingUploadRow(element)) {
                            <bic-dropdown-element
                              (click)="$event.stopPropagation(); renameFile(element); contextMenuDropdown.hide()">
                              <fa-icon [icon]="faPenToSquare" iconLeft></fa-icon>
                              <span>Umbenennen</span>
                            </bic-dropdown-element>
                          } @else {
                            <bic-dropdown-element
                              [disabled]="true"
                              [tooltip]="'Diese Datei wird noch hochgeladen und kann erst danach umbenannt werden.'">
                              <fa-icon [icon]="faPenToSquare" iconLeft></fa-icon>
                              <span class="text-gray-400">Umbenennen (nicht verfügbar)</span>
                            </bic-dropdown-element>
                          }
                        }
                      }
                      @if (permissionService.hasProjectPrivilege('PROJECT_FILE_DELETE')) {
                        @if (!calledFromCheck && element.sourceLinkId) {
                          <bic-dropdown-element [disabled]="true" [tooltip]="mirroredHint">
                            <fa-icon iconLeft [icon]="faTrash"></fa-icon>
                            <span class="text-gray-400">Löschen (in SharePoint)</span>
                          </bic-dropdown-element>
                        } @else if (!calledFromCheck) {
<bic-dropdown-element (click)="$event.stopPropagation(); deleteFile(element)"
                                             >
                          <fa-icon iconLeft [icon]="faTrash" class="text-red"></fa-icon>
                          <span class="text-red">Löschen</span>
                        </bic-dropdown-element>
}
                      }
                    </bic-dropdown>
                  </cdk-cell>

                </ng-container>
}


                <cdk-header-row *cdkHeaderRowDef="columns; sticky:true"
                                [style.min-width]="tableMinWidth + 'px'"
                                [style.width]="'100%'"
                                class="flex flex-row justify-start items-center font-semibold border-b text-xs text-gray-400 uppercase select-none h-[42px] bg-gray-50 border-gray-200"></cdk-header-row>

                <cdk-row *cdkRowDef="let row; columns: columns;"
                         [style.min-width]="tableMinWidth + 'px'"
                         [style.width]="'100%'"
                         (dblclick)="navigateIntoFolder(row)"
                         (mouseenter)="hoveredRow = row" (mouseleave)="hoveredRow = null"
                         (click)="selectedRow(row)"
                         [ngClass]="{
                          'bg-gray-100': hoveredRow == row || highlightedRow == row,
                          'border-none': row.index == 0,
                          }"
                         class="flex flex-row justify-start items-center text-gray border-t border-gray-300 first:border-none hover:bg-gray-100 hover:cursor-pointer">
                </cdk-row>
              </cdk-table>
            </div>
          }
        </div>

      </div>

    </div>
    @if (detailedInfos) {
      <!-- Infopanel zeigt nur die sichtbare Auswahl (#2770). -->
      @let visibleSelection = visibleSelectedFiles();
      <div
        class="flex flex-col h-full border border-gray-200 p-4 rounded-lg justify-between items-center w-[380px] shrink-0 overflow-y-auto">
        <div class="flex flex-col w-full gap-4">
          @if (visibleSelection.length == 1) {
            <div class="flex flex-row w-full gap-2">
              @if (visibleSelection[0]?.fileType == 'PDF') {
                <fa-icon [icon]="faFilePdf" class="text-gray"></fa-icon>
              }
              @if (visibleSelection[0]?.fileType == 'IFC') {
                <fa-icon [icon]="faIfc" class="text-gray"></fa-icon>
              }
              @if (visibleSelection[0]?.fileType == 'WORD') {
                <fa-icon [icon]="faFileDoc" class="text-gray"></fa-icon>
              }
              @if (visibleSelection[0]?.fileType == 'EXCEL') {
                <fa-icon [icon]="faFileXls" class="text-gray"></fa-icon>
              }
              @if (visibleSelection[0]?.fileType == 'POWERPOINT') {
                <fa-icon [icon]="faFilePpt" class="text-gray"></fa-icon>
              }
              @if (visibleSelection[0]?.fileType == 'COORDINATION') {
                <fa-icon [icon]="faLayerGroup" class="text-gray"></fa-icon>
              }
              <span class="break-all w-full">{{ visibleSelection[0]?.name ?? "-" }}</span>
            </div>
          }
          @if (visibleSelection.length != 1) {
            <span>{{ numberOfSelectedFilesWithoutFolder() }} Elemente ausgewählt</span>
          }
          <div class="flex flex-col w-full rounded-lg border-gray-200 border">
            <div class="flex flex-row w-full h-48 bg-gray-50 rounded-lg justify-center items-center ">
              @if (visibleSelection.length == 1) {
                @if (visibleSelection[0]?.fileType == 'PDF') {
                  <fa-icon [icon]="faFilePdf"
                           class="text-gray-300 text-[70px]"></fa-icon>
                }
                @if (visibleSelection[0]?.fileType == 'IFC') {
                  <fa-icon [icon]="faIfc"
                           class="text-gray-300 text-[70px]"></fa-icon>
                }
                @if (visibleSelection[0]?.fileType == 'WORD') {
                  <fa-icon [icon]="faFileDoc"
                           class="text-gray-300 text-[70px]"></fa-icon>
                }
                @if (visibleSelection[0]?.fileType == 'EXCEL') {
                  <fa-icon [icon]="faFileXls"
                           class="text-gray-300 text-[70px]"></fa-icon>
                }
                @if (visibleSelection[0]?.fileType == 'POWERPOINT') {
                  <fa-icon [icon]="faFilePpt"
                           class="text-gray-300 text-[70px]"></fa-icon>
                }
                @if (visibleSelection[0]?.fileType == 'COORDINATION') {
                  <fa-icon [icon]="faLayerGroup"
                           class="text-gray-300 text-[70px]"></fa-icon>
                }
              }
              @if (visibleSelection.length != 1) {
                <fa-icon [icon]="faLayerGroup" class="text-gray-300 text-[70px]"></fa-icon>
              }
            </div>
          </div>
          @if (visibleSelection.length == 1) {
            <div class="flex flex-col w-full gap-2">
              <div class="flex flex-row w-full justify-between"><span class="text-sm text-gray-500">Typ</span>
                <span class="text-sm font-medium text-gray">
          {{
                    visibleSelection[0]?.fileType === ProjectFile.FileTypeEnum.FOLDER
                      ? 'Ordner'
                      : (($safeNavigationMigration(visibleSelection[0]?.fileType) | fileType) ?? '-')
                  }}</span>
              </div>
              <div class="flex flex-row w-full justify-between"><span class="text-sm text-gray-500">Größe</span>
                <span
                  class="text-sm font-medium text-gray">
      @if (calculateSizeInMB($safeNavigationMigration(visibleSelection[0]?.size)) > 1024) {
        @if (calculateSizeInGB($safeNavigationMigration(visibleSelection[0]?.size)) < 10) {
          {{ calculateSizeInGB($safeNavigationMigration(visibleSelection[0]?.size)) | number: '.0-2' }} GB
        }
        @if (calculateSizeInGB($safeNavigationMigration(visibleSelection[0]?.size)) >= 10) {
          {{ calculateSizeInGB($safeNavigationMigration(visibleSelection[0]?.size)) | number: '.0-1' }} GB
        }
      }
                  @if (calculateSizeInMB($safeNavigationMigration(visibleSelection[0]?.size)) <= 1024) {
                    @if (calculateSizeInMB($safeNavigationMigration(visibleSelection[0]?.size)) < 10) {
                      {{ calculateSizeInMB($safeNavigationMigration(visibleSelection[0]?.size)) | number: '.0-2' }} MB
                    }
                    @if (calculateSizeInMB($safeNavigationMigration(visibleSelection[0]?.size)) >= 10) {
                      {{ calculateSizeInMB($safeNavigationMigration(visibleSelection[0]?.size)) | number: '.0-1' }} MB
                    }
                  }
    </span>
              </div>
              <div class="flex flex-row w-full border border-gray-200"></div>
              <div class="flex flex-row w-full justify-between"><span
                class="text-sm text-gray-500">Zuletzt geändert am</span> <span
                class="text-sm font-medium text-gray">{{ ($safeNavigationMigration(visibleSelection[0]?.lastModified)  | date: 'dd.MM.yyyy') ?? "-" }}</span>
              </div>
              <div class="flex flex-row w-full justify-between"><span
                class="text-sm text-gray-500">Zuletzt bearbeitet von</span> <span
                class="text-sm font-medium text-gray">{{ visibleSelection[0]?.lastModifiedBy ?? "-" }}</span></div>
              <div class="flex flex-row w-full justify-between"><span
                class="text-sm text-gray-500">Erstellt am</span>
                <span
                  class="text-sm font-medium text-gray">{{ ($safeNavigationMigration(visibleSelection[0]?.created)  | date: 'dd.MM.yyyy') ?? "-" }}</span>
              </div>
              <div class="flex flex-row w-full justify-between"><span
                class="text-sm text-gray-500">Erstellt von</span>
                <span class="text-sm font-medium text-gray">{{ visibleSelection[0]?.createdBy ?? "-" }}</span></div>
              <div class="flex flex-row w-full border border-gray-200"></div>
              <div class="flex flex-row w-full justify-between"><span class="text-sm text-gray-500">Status</span>
                <span
                  class="text-sm font-medium text-gray">{{ $safeNavigationMigration(visibleSelection[0]?.fileStatus) | fileStatus }}</span></div>
              @if (visibleSelection[0]?.fileStatus === ProjectFile.FileStatusEnum.ERROR && visibleSelection[0]?.errorReason) {
                <div class="flex flex-row w-full justify-between gap-2"><span
                  class="text-sm text-gray-500 shrink-0">Fehlergrund</span> <span
                  class="text-sm font-medium text-gray-700 text-right break-words">{{ visibleSelection[0]?.errorReason }}</span>
                </div>
              }
              @if (visibleSelection[0]?.fileType === ProjectFile.FileTypeEnum.COORDINATION && visibleSelection[0]?.linkedFiles && visibleSelection[0]?.linkedFiles!.length > 0) {
                <div class="flex flex-row w-full border border-gray-200"></div>
                <div class="flex flex-col gap-1.5">
                  <span
                    class="text-sm text-gray-500">Verknüpfte IFC-Dateien ({{ visibleSelection[0]?.linkedFiles!.length }}
                    )</span>
                  @for (linked of visibleSelection[0]?.linkedFiles; track linked.id) {
                    <div class="flex items-center gap-2 text-xs text-gray-700 px-2 py-1 bg-gray-50 rounded truncate">
                      <fa-icon [icon]="faIfc" class="text-gray-400 shrink-0"></fa-icon>
                      <span class="truncate">{{ linked.name }}</span>
                    </div>
                  }
                </div>
              }
              <!--              <div class="flex flex-row w-full justify-between"><span-->
              <!--                class="text-sm text-gray-500">Zuletzt geprüft am</span> <span-->
              <!--                class="text-sm font-medium text-gray">{{ "-" }}</span></div>-->
              <!--              <div class="flex flex-row w-full justify-between"><span-->
              <!--                class="text-sm text-gray-500">Zuletzt geprüft von</span> <span-->
              <!--                class="text-sm font-medium text-gray">{{ "-" }}</span></div>-->
              <!--              <div class="flex flex-row w-full justify-between"><span class="text-sm text-gray-500 underline">Zur letzten Prüfung</span>-->
              <!--              </div>-->
              <!--              <div class="flex flex-row w-full border border-gray-200"></div>-->
              <!--              @if (selectedFiles[0].classificationRules && selectedFiles[0].classificationRules.length > 0) {-->
              <!--                <div class="flex flex-row w-full justify-between"><span-->
              <!--                  class="text-sm text-gray-500">Klassifizierung</span>-->
              <!--                </div>-->
              <!--                <div>-->
              <!--                  <ul class="list-none p-0 m-0">-->
              <!--                    @for (classification of selectedFiles[0].classificationRules; track classification.id) {-->
              <!--                      <li class="text-sm text-gray-500">{{ classification.name }}</li>-->
              <!--                    }-->
              <!--                  </ul>-->
              <!--                </div>-->
              <!--              }-->
              <!--              <div class="flex flex-row w-full border border-gray-200"></div>-->
              <!--              <div class="flex flex-row w-full justify-between"><span class="text-sm text-gray-500">Erfolgreich geprüfte Teilleistungen</span>-->
              <!--              </div>-->
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
